// extracted by css-extract-rspack-plugin
export default {"noDecoration":"NSGG8","link":"ioZ9X","linkWrappable":"MBDvb"};